import {useEffect, useState} from 'react';
import {ActionIcon, Menu} from '@mantine/core';
import {IconChevronDown} from '@tabler/icons-react';
import classes from './LanguagePicker.module.css';
import i18n from "i18next";
import {LanguageUtils} from "../../utils/LanguageUtils";
import {AccountService} from "../../services/AccountService";


export function LanguagePicker() {
    const [opened, setOpened] = useState(false);
    const [selected, setSelected] = useState({label: "", id: 0, code: ""});

    const data = [
        {label: "FR", id: 5, code: "fr_BE"},
        {label: "NL", id: 2, code: "nl_BE"},
    ];

    useEffect(() => {
        const userLanguage = LanguageUtils.getLocale();
        if (userLanguage) {
            userLanguage === "fr_BE" ? setSelected(data[0]) : setSelected(data[1]);
        }
    }, []);

    const onChangeLanguage = (item : any) => {

        const language = {
            id: item.id,
            name: item.code
        };

        if (AccountService.getLanguageLocalStorage() === null) {
            AccountService.saveLanguageLocal(language);
        } else {
            AccountService.updateLanguageLocalToken(item.code, item.id);
        }

        setSelected(item);
        i18n.changeLanguage(item.code);
    }

    const items = data.map((item, index) => (
        <Menu.Item
            onClick={() => {
                onChangeLanguage(item)
            }}
            key={index}
        >
            {item.label}
        </Menu.Item>
    ));

    return (
        <Menu
            onOpen={() => setOpened(true)}
            onClose={() => setOpened(false)}
            radius="xs"
            withinPortal
        >
            <Menu.Target>
                <ActionIcon className={classes.control} data-expanded={opened || undefined}
                            variant="default"
                            size="lg">
                    <span className={classes.label}>{selected.label}</span>
                    <IconChevronDown size="1rem" className={classes.icon} stroke={1.5}/>
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>{items}</Menu.Dropdown>
        </Menu>
    );
}